module.exports = __webpack_public_path__ + "img/cloud.a4275bf0.svg";